import type { ObjectId } from "@bbj-types/utils";
import type { CreateAction } from "@root/utils/enums/communication";
import { useCallback } from "react";
import { axios } from "./axios";

interface IGetCoachingSummary {
  candidate: ObjectId;
  summaryText: string;
  synthesis: string;
}

interface IGetCoachingSummaryQuery {
  candidateIds: ObjectId[];
  startDate: Date;
}

interface ICoachingSummarEmail {
  addresses: string[];
  content: string;
  subject: string;
  cc?: string[];
}

export interface IPostCoachingSummaryEmails {
  email: ICoachingSummarEmail;
  candidateIds: ObjectId[];
  createAction: CreateAction;
}

export const useGetCoachingSummary = () => {
  const [state, execute, cancel] = axios<IGetCoachingSummary[], void, unknown>(
    {
      url: "/candidates/coachingSummary",
      method: "GET",
      withCredentials: true,
    },
    { manual: true }
  );

  const executeWrapper = useCallback(
    (candidateIds: IGetCoachingSummaryQuery["candidateIds"], startDate: IGetCoachingSummaryQuery["startDate"]) => {
      return execute({
        params: { candidateIds, startDate },
      });
    },
    [execute]
  );

  return [state, executeWrapper, cancel] as const;
};

export const usePostCoachingSummaryEmails = () => {
  const [state, execute, cancel] = axios<void, IPostCoachingSummaryEmails, unknown>(
    {
      url: "/candidates/coachingSummary/email",
      method: "POST",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (data: IPostCoachingSummaryEmails) => {
      return execute({
        data,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
